import { fetchHTML } from './utils-fetch-html.js';

class QuickShop extends HTMLElement {
  static {
    // When a product is added to the cart, close the quick shop dialog
    subscribe('cart:added', ({ items }) => {
      publish('dialog:close', { dialogId: `quick-shop-dialog-${items[0].product_id}` });
    });
  }

  connectedCallback() {
    this.addEventListener('click', (event) => this.handleClick(event));
    this.productId = this.dataset.productId;
    this.url = this.dataset.url;
  }

  /**
   * Handle click.
   */
  async handleClick(event) {
    // if click is on not on the button, do not fetch
    if (!event.target.closest('[data-dialog-controller]')) return;
    if (!this.productId) return;

    const target = document.querySelector(`#quick-shop-dialog-${this.productId} .dialog__content`);

    // Do not fetch if there is content already fetched
    if (target.querySelector('#shopify-section-fetch-quick-shop')) return;

    try {
      const html = await fetchHTML(`${this.url}?section_id=fetch-quick-shop`);
      target.innerHTML = html.getElementById('shopify-section-fetch-quick-shop').innerHTML;
    } catch (error) {
      console.error('Error fetching quick shop content:', error);
    }
  }
}

customElements.define('quick-shop', QuickShop);
